import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

// -------

import axios from 'app/services/http/axios';
import {Actions} from './slice';
import { objectToUrl, routePath } from 'app/services/helpers'

import { Api } from 'modules/Admin/Reports'

// -------

function* getList({payload: {pageNumber, filters}}) {

  try {
    let route = Api.reports;
    route += objectToUrl({
      ...filters,
      page: pageNumber,
      with: 'formType,company,creator'
    }, true)

    const response = yield call(axios.get, route);
    yield put(Actions.getListSuccess(response));

  } catch (e) {
    return yield put(Actions.getListFailed(e));
  }
}

// ------- GET FILTERS

function* getFormFilters() {
  try {
    const response = yield call(axios.get, Api.formFilters);

    // Response contains both formTypes and companies
    const { formTypes = [], companies = [] } = response || {};

    console.log('Form Filters Response:', response);
    console.log('Form Types:', formTypes);
    console.log('Companies:', companies);

    yield put(Actions.getFormFiltersSuccess({
      formTypes: Array.isArray(formTypes) ? formTypes : [],
      companies: Array.isArray(companies) ? companies : []
    }));

  } catch (e) {
    console.error('Get form filters error:', e);
    return yield put(Actions.getFormFiltersFailed(e));
  }
}

// ------- ACTIONS

function* toDelete({payload: {id, reason}}) {
  try {
    let route = `${Api.reports}/${id}`;
    // Send reason as request body for DELETE request
    const response = yield call(axios.delete, route, {
      data: { reason }
    });
    yield put(Actions.toDeleteSuccess(response));
    toast.success('Report deleted successfully');
  } catch (e) {
    toast.error('Failed to delete report');
    return yield put(Actions.toDeleteFailed(e));
  }
}

function* toApprove({payload: {id}}) {
  try {
    let route = routePath(Api.reportApprove, {id});
    const response = yield call(axios.post, route);
    yield put(Actions.toApproveSuccess(response));
    toast.success('Report approved successfully');
  } catch (e) {
    toast.error('Failed to approve report');
    return yield put(Actions.toApproveFailed(e));
  }
}

function* toReject({payload: {id}}) {
  try {
    let route = routePath(Api.reportReject, {id});
    const response = yield call(axios.post, route);
    yield put(Actions.toRejectSuccess(response));
    toast.success('Report rejected successfully');
  } catch (e) {
    toast.error('Failed to reject report');
    return yield put(Actions.toRejectFailed(e));
  }
}

// -------

export function* watchReportsListSaga() {
  yield takeLatest(Actions.getList.type, getList)
  yield takeLatest(Actions.getFormFilters.type, getFormFilters)
  yield takeLatest(Actions.toDelete.type, toDelete)
  yield takeLatest(Actions.toApprove.type, toApprove)
  yield takeLatest(Actions.toReject.type, toReject)
}

export default watchReportsListSaga
